import { Alert, Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';

export function BookingReviewNotice({
  required,
  compact = false,
}: {
  required?: boolean;
  compact?: boolean;
}) {
  const { t } = useTranslation('workorders');
  if (!required) return null;
  return compact ? (
    <Chip size="small" color="warning" label={t('whatsappReview.label')} />
  ) : (
    <Alert severity="warning" sx={{ mb: 2 }}>
      {t('whatsappReview.description')}
    </Alert>
  );
}
